(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbSubformGroup', fbSubformGroupDirective);

    function fbSubformGroupDirective() {
        return {
            restrict: "EA",
            scope: {
                fbElement: '=',
                model: '=',
                renderedElements: '='
            },
            templateUrl: 'common/libraries/formBuilder/subform/group',
            require: "^fbFormGenerator",
            controller: fbSubformGroupDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbSubformGroupDirectiveCtrl(FormBuilderHelper, $scope, CommonHelper) {
        var vm = this;
        this.$onInit = function() {
            vm.generateChildIdentifier = generateChildIdentifier;
            vm.determineDisabled = FormBuilderHelper.determineDisabled;
            vm.currentElementIdentifier = $scope.$parent.vm.elementIdentifier;

            vm.formIdentifier = $scope.$parent.vm.formIdentifier;
            vm.getElementSize = FormBuilderHelper.getElementSize;
            if (CommonHelper.isEmpty(vm.model)) {
                // if (typeof vm.model === typeof undefined || vm.model === null) {
                vm.model = {};
            }
        }

        function generateChildIdentifier(element_name) {
            return vm.currentElementIdentifier + '.' + element_name;
        }
    }
})();